/* ATN Membership - Section 09: FAQ accordions */
/* Independent toggle accordions. Buttons are native <button> so keyboard
   (Enter/Space) works out of the box. Recomputes open heights on resize.
   Re-inits on Shopify section load. */
(function () {
  function bind(root) {
    if (!root) return;
    var items = root.querySelectorAll('[data-faq-item]');

    items.forEach(function (item) {
      var btn = item.querySelector('[data-faq-q]');
      var panel = item.querySelector('[data-faq-a]');
      if (!btn || !panel || btn.dataset.faqBound === '1') return;
      btn.dataset.faqBound = '1';

      btn.addEventListener('click', function () {
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '';
      });
    });

    if (!root.dataset.faqResize) {
      root.dataset.faqResize = '1';
      window.addEventListener('resize', function () {
        root.querySelectorAll('[data-faq-item].is-open [data-faq-a]').forEach(function (panel) {
          panel.style.maxHeight = panel.scrollHeight + 'px';
        });
      });
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-atn-mem-faq]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-atn-mem-faq]');
    if (el) bind(el);
  });
})();